export default function printMovement(startDate, endDate) {
  const token = localStorage.getItem("token");
  printMovementProduct(token, startDate, endDate)
}
function printMovementProduct(token, startDate, endDate) {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/produtos-logs/find/product/per/period?auth=${token}&startDate=${startDate}&endDate=${endDate}`
  );
}